// @flow

import React              from 'react';
import { Switch, Route }  from 'react-router-dom'
import ProtectedRoute     from 'components/common/protectedRoute/protectedRoute.js';
import NotFound           from 'components/common/notFound/notFound.js';
import ServiceUnavailable from 'components/common/serviceUnavailable/serviceUnavailable.js';
import Session            from 'components/session';
import Main               from 'components/main';
import AccountDeleted     from 'components/common/accountDeleted';
import MailHasBeenSent    from 'components/common/mailHasBeenSent/mailHasBeenSent.js'

const Routes = () => (
  <Switch>
    <Route exact path="/service-unavailable" component={ServiceUnavailable} />
    <Route exact path="/account-deleted" component={AccountDeleted} />
    <Route exact path='/mail-has-been-sent' component={MailHasBeenSent} />

    {['/', '/special-deals', '/special-deals/kvittering/:companySeoName', '/settings', '/company-branding/:companySeoName/:companyAppId', '/help'].map((path, index) =>
      <ProtectedRoute exact key={index} path={path} component={Main} />
    )}

    <Session />
    <Route component={NotFound} />
  </Switch>
)

export default Routes;



// WEBPACK FOOTER //
// ./src/containers/routes.js